module.exports = __webpack_public_path__ + "static/media/pic33.fa48d9b6.JPG";